import React from 'react';

import Image from '../assets/img/house-banner.png';

const Banner = () => {
  return (
    <section className='h-full max-h-[640px] mb-8 xl:mb-24'>
      <div className='flex flex-col lg:flex-row'>
        <div className='lg:ml-36 xl:ml-[80px] sm:mt-[25px] flex flex-col items-left lg:items-start text-left lg:text-left justify-center flex-1 px-4 lg:px-0 bg-#F7FAFD'>
          <h1 className='text-4xl lg:text-[50px] md:text-[30px] sm:text-[30px]  font-semibold leading-none mb-6 '>
            <span className='text-black' >HomeStays — <br /></span> <span className='text-black'>your perfect space with
            us.</span>
          </h1>
          <p className='max-w-[480px] mb-8 lg:text-[12px] md:text-[09px] sm:text-[9px] font-semibold '>
         
          Located in Eilat and with Papaya Beach reachable within 1.4 km, Exodus Hostel & Dive Center provides express check-in and check-out, allergy-free rooms, a shared lounge, free WiFi and a garden. 
          
          
          {/* Featuring a shared kitchen, this property also provides guests with a barbecue. Certain units at the property include a terrace with a city view. */}


          </p>
        </div>
        <div className='hidden flex-1 lg:flex justify-end items-end'>
          <img src={Image} alt='' />
        </div>
      </div>
    </section>
  );
};

export default Banner;